/* unplugin-vue-components disabled */import { render } from "./PopupAppYearShare.vue?vue&type=template&id=619dff8d"
import script from "./PopupAppYearShare.vue?vue&type=script&lang=js"
export * from "./PopupAppYearShare.vue?vue&type=script&lang=js"

import "./PopupAppYearShare.vue?vue&type=style&index=0&id=619dff8d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__